<div class="row" style="margin-top:60px">
  <div class="col-12 col-md-6 offset-md-3">
    <ul class="list-group mt-3">
      <li class="list-group-item p-3 bg_light">
        <span style="font-size:25px" class="c_bluedk"><i class="fas fa-fw fa-info-circle me-2"></i>Application Information</span>
      </li>
      <li class="list-group-item bg_light">
        <span class="c_blue bolder me-2">Version:</span> {{ version }}
      </li>
      <li class="list-group-item bg_light">
        <span class="c_blue bolder me-2">Release Date:</span> {{ releaseDate }}
      </li>
      <li class="list-group-item bg_light">
        <span class="c_blue bolder me-2">Environment:</span>{{ environment }}
      </li>
      <li class="list-group-item bg_light">
        <span class="c_blue bolder me-2">User Info:</span><br />
          <div class="row">
            <div class="col-12 col-md-8 pt-2">
              E-mail Address: {{ userEmail }}<br />
              Is Admin: {{ (!userAdmin) ? 'No' : 'Yes' }}<br />
              Time Zone: {{userTimeZone}}<br />
            </div>
          </div>
      </li>
    </ul>
  </div>
</div>
